
































































































































import {
  numericOnly,
  currencyFormat,
  changeCurrencytoNumeric,
} from "@/validator/globalvalidator";
import moment from "moment";
import Vue, { PropType } from "vue";
import { DEFAULT_DATE_FORMAT } from "@/models/constants/date.constant";
import {
  AssetBookRelations,
  AssetCostHistories,
  ResponseGetDetailInquiry,
} from "@/models/interface/assets.interface";
import { debounce } from "@/helpers/debounce";
export default Vue.extend({
  props: {
    dataAssetHistory: {
      type: Object as PropType<ResponseGetDetailInquiry>,
    },
    currentTab: String,
  },
  data() {
    return {
      DEFAULT_DATE_FORMAT,
      formatNumeric: numericOnly,
      formatCurrency: currencyFormat,
      formatCurrencytoNumber: changeCurrencytoNumeric,
      loading: false as boolean,
      selectedRowKeys: [],
      depreciateCheckBox: true as boolean,
      totalElements: 1 as number,
      totalElementsDetails: 1 as number,
      limit: 10 as number,
      limitDetails: 10 as number,
      form: this.$form.createForm(this, { name: "openCost" }),
      formRules: {
        originalCost: {
          label: "lbl_original_cost",
          name: "originalCost",
          placeholder: "lbl_original_cost_placeholder",
          decorator: ["originalCost"],
        },
        salvageValue: {
          label: "lbl_salvage_value",
          name: "salvageValue",
          placeholder: "lbl_salvage_value_placeholder",
          decorator: ["salvageValue"],
        },
        acquisitionDate: {
          label: "lbl_acquisition_date",
          name: "acquisitionDate",
          placeholder: "lbl_acquisition_date_placeholder",
          decorator: ["acquisitionDate"],
        },
        method: {
          label: "lbl_method",
          name: "method",
          placeholder: "lbl_method_placeholder",
          decorator: ["method"],
        },
        lifeMonths: {
          label: "lbl_life_months",
          name: "lifeMonths",
          placeholder: "lbl_life_months_placeholder",
          decorator: ["lifeMonths"],
        },
        remainingLifeMonths: {
          label: "lbl_remaining_life_month",
          name: "remainingLifeMonths",
          placeholder: "lbl_remaining_life_months_placeholder",
          decorator: ["remainingLifeMonths"],
        },
        depreciate: {
          label: "lbl_depreciate",
          name: "depreciate",
          placeholder: "lbl_depreciate_placeholder",
        },
      },
      dataSource: [] as AssetBookRelations[],
      columnsTable: [
        {
          title: "Book",
          dataIndex: "bookName",
          key: "bookName",
        },
        {
          title: "Cost",
          dataIndex: "customCurrentCostAsset",
          key: "customCurrentCostAsset",
        },
        {
          title: "Net Book Value",
          dataIndex: "customNetBookValue",
          key: "customNetBookValue",
        },
        {
          title: "YTD Depreciation",
          dataIndex: "customYtdDepre",
          key: "customYtdDepre",
        },
        {
          title: "Accumulated Depreciation",
          dataIndex: "customAccumulateDepre",
          key: "customAccumulateDepre",
        },
      ],
      dataSourceDetails: [] as AssetCostHistories[],
      columnsTableDetails: [
        {
          title: "Transaction Type",
          dataIndex: "transactionType",
          key: "transactionType",
        },
        {
          title: "Transaction Date",
          dataIndex: "transactionDate",
          key: "transactionDate",
        },
        {
          title: "Periods Entered",
          dataIndex: "period",
          key: "period",
        },
        {
          title: "Cost",
          dataIndex: "customCostChange",
          key: "customCostChange",
        },
      ],
    };
  },
  methods: {
    onSelectChange(value) {
      this.selectedRowKeys = value;
      this.dataSourceDetails = this.dataSource[value[0]].assetCostHistories;
      this.depreciateCheckBox = this.dataSource[value[0]].depreciate;
      this.form.setFieldsValue({
        acquisitionDate: this.dataSource[value[0]].acquisitionDate,
      });
    },
  },
  watch: {
    dataAssetHistory: {
      immediate: true,
      deep: true,
      handler(newValue) {
        debounce(() => {
          this.form.setFieldsValue({
            originalCost: newValue.originalCost,
            salvageValue: newValue.salvageValue,
            acquisitionDate: newValue.acquisitionDate
              ? moment(newValue.acquisitionDate, "DD-MMM-yyyy")
              : null,
            method: newValue.bookMethod,
            lifeMonths: newValue.lifeMonths,
            remainingLifeMonths: newValue.remainingLifeMonth,
          });
          this.depreciateCheckBox = newValue.depreciate;
          this.dataSource = newValue.assetBookRelations;
        }, 500);
      },
    },
    dataSourceDetails() {
      this.dataSourceDetails.forEach(dataMap => {
        dataMap.customCostChange = currencyFormat(dataMap.costChange);
      });
    },
    dataSource() {
      if (this.dataSource && this.dataSource.length > 0) {
        this.dataSource.forEach(dataMap => {
          dataMap.customCurrentCostAsset = currencyFormat(
            dataMap.currentCostAsset
          );
          dataMap.customNetBookValue = currencyFormat(dataMap.netBookValue);
          dataMap.customYtdDepre = currencyFormat(dataMap.ytdDepre);
          dataMap.customAccumulateDepre = currencyFormat(
            dataMap.accumulateDepre
          );
        });
      }
    },
  },
  computed: {
    formItemLayout() {
      return {
        labelCol: { span: 8 },
        wrapperCol: { span: 14 },
      };
    },
  },
});
